import { useState, useEffect } from "react";
import { lookupsApi } from "../api/lookups";

// Module-level cache so lookups are fetched once per session, not per component mount.
const _cache = {};

export function useLookups(category) {
  const [types,   setTypes]   = useState(_cache[category] || []);
  const [loading, setLoading] = useState(!_cache[category]);

  useEffect(() => {
    if (_cache[category]) {
      setTypes(_cache[category]);
      setLoading(false);
      return;
    }
    lookupsApi.list(category)
      .then(({ data }) => {
        _cache[category] = data;
        setTypes(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  const colorFor = (id) => types.find((t) => t.id === id)?.color ?? "gray";
  const labelFor = (id) => types.find((t) => t.id === id)?.label ?? "—";

  return { types, loading, colorFor, labelFor };
}

// Call this to bust the cache after an admin edit so dropdowns refresh.
export function invalidateLookupCache(category) {
  if (category) {
    delete _cache[category];
  } else {
    Object.keys(_cache).forEach((k) => delete _cache[k]);
  }
}
